import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var vibrateShort = normalize(function (_ref) {
  var success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;

  if (isDingdingMiniapp) {
    dd.vibrateShort({
      success: success,
      fail: fail,
      complete: complete
    });
  } else {
    my.vibrateShort(function () {
      success && success();
      complete && complete();
    });
  }
}, CONTAINER_NAME.ALIPAY);
export default vibrateShort;